import { z } from 'zod';
import { FormTargetProfile } from './care-form.schema';

// --- Enums ---
export const BarrierType = z.enum(['NONE', 'PAYWALL', 'PROGRAM_ADHESION']);
export const SubscriptionFrequency = z.enum(['WEEKLY', 'MONTHLY', 'YEARLY', 'LIFETIME']);
export const BlockedFeature = z.enum(['CHAT_EVA', 'CHAT_CRM', 'CHAT_PARTNER', 'CONTENT']);

// --- Paywall ---
export const PromotionSchema = z.object({
    active: z.boolean().default(true),
    startDate: z.date(),
    endDate: z.date(),
    promotionalPrice: z.number().min(0),
    label: z.string().optional(),
});

export const SubscriptionPlanSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    frequency: SubscriptionFrequency,
    price: z.number().min(0),
    description: z.string().optional(),
    promotions: z.array(PromotionSchema).default([]),
});

export const PaywallConfigSchema = z.object({
    enabled: z.boolean().default(false),
    gateway: z.string(), // e.g. 'stripe', 'pagarme', or custom description
    plans: z.array(SubscriptionPlanSchema).default([]),
});

// --- Adhesion Form ---
export const AdhesionFormLinkSchema = z.object({
    targetProfile: FormTargetProfile,
    formId: z.string().uuid(),
});

export const AdhesionFormConfigSchema = z.object({
    programName: z.string(),
    forms: z.array(AdhesionFormLinkSchema).default([]),
});

// --- Main Barrier Config ---
export const BarrierConfigSchema = z.object({
    type: BarrierType.default('NONE'),
    paywall: PaywallConfigSchema.optional(),
    adhesion: AdhesionFormConfigSchema.optional(),

    // Which features are blocked?
    blockedFeatures: z.array(BlockedFeature).default([]),

    // Global Master Switch for internal Eva Magazines
    evaMagazinesLocked: z.boolean().default(true).optional(),
});

export const GlobalBarrierSchema = z.object({
    id: z.string(),
    config: BarrierConfigSchema,
    updatedAt: z.date(),
});

export type BarrierType = z.infer<typeof BarrierType>;
export type SubscriptionFrequency = z.infer<typeof SubscriptionFrequency>;
export type BlockedFeature = z.infer<typeof BlockedFeature>;
export type Promotion = z.infer<typeof PromotionSchema>;
export type SubscriptionPlan = z.infer<typeof SubscriptionPlanSchema>;
export type PaywallConfig = z.infer<typeof PaywallConfigSchema>;
export type AdhesionFormLink = z.infer<typeof AdhesionFormLinkSchema>;
export type AdhesionFormConfig = z.infer<typeof AdhesionFormConfigSchema>;
export type BarrierConfig = z.infer<typeof BarrierConfigSchema>;
export type GlobalBarrier = z.infer<typeof GlobalBarrierSchema>;


